import { Component, OnInit, ElementRef, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

/**
 * Component wrapper for ProfileTemplatesController
 */
@Component({
  selector: 'profile-templates-list',
  template: '<profile-templates-list-directive></profile-templates-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProfileTemplatesListComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    // No route params needed for list component
  }
}

/**
 * Directive for downgrading ProfileTemplatesListComponent
 */
@Component({
  selector: 'profile-templates-list-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProfileTemplatesListDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('profileTemplatesList', elementRef, injector);
  }
}

/**
 * Component wrapper for ProfileTemplateController (form)
 */
@Component({
  selector: 'profile-template-form',
  template: '<profile-template-form-directive [id]="id"></profile-template-form-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProfileTemplateFormComponent {
  @Input()id: string;
}

/**
 * Directive for downgrading ProfileTemplateFormComponent
 */
@Component({
  selector: 'profile-template-form-directive',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProfileTemplateFormDirective extends UpgradeComponent {
  @Input() id: string;
  @Input() template: any;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('profileTemplateForm', elementRef, injector);
  }
}
